import { useContext } from 'react'
import ChannelContext from '../context/ChannelContext'
import { fixPath } from '../utils/path'

export const useLink = () => {
  const channel = useContext(ChannelContext)

  const getHref = (href: string): string => {
    if (!href) return ''

    if (href.startsWith('http://') || href.startsWith('https://')) {
      return href
    }

    if (href.startsWith(channel.current.path)) {
      //console.log('useLink: href already has channel path', { href, channelPath: channel.current.path, result: fixPath(href) })
      return fixPath(href)
    }
    const result = fixPath(`${channel.current.path}${href}`)
    //console.log('useLink: adding channel path', { href, channelPath: channel.current.path, result })
    return result
  }

  return { getHref }
}

export default useLink
